import moment, { MomentInput } from "moment-timezone";
import { TDay } from "../components/scrollable-calendar-view/ScrollableCalendarView";

/**
 * get events by type
 */
export function getEventsByType<T>({
  start,
  end,
  timezone,
  dates,
  event,
  accum,
  splitBetweenDays,
  disableFullDay,
}: {
  start: MomentInput;
  end: MomentInput;
  timezone: TimeZone;
  dates: {
    [key in TDay]: Date;
  };
  event: T;
  accum: {
    fullDay: {
      [key in TDay]: typeof event[];
    };
    nonFullDay: {
      [key in TDay]: typeof event[][];
    };
  };
  splitBetweenDays?: boolean;
  disableFullDay?: boolean;
}) {
  const startDate = moment.tz(start, timezone);
  const endDate = moment.tz(end, timezone);
  const startDateStartOfDay = startDate.clone().startOf("days");

  const startDateItemId = Object.values(dates).findIndex((el) => {
    return moment.tz(el, timezone).isSame(startDateStartOfDay, "days");
  });

  const lengthInDays = endDate.diff(startDate, "days", true);
  if (lengthInDays >= 1 && !disableFullDay) {
    const day = Object.keys(dates)[startDateItemId];
    if (day) {
      accum.fullDay[day] = [...(accum.fullDay[day] || []), event];
    }
    return accum;
  }

  const day = Object.keys(dates)[startDateItemId];
  if (day) {
    const hour = startDate.hours();
    const nextDay = accum.nonFullDay[day] || [];
    nextDay[hour] = [...(nextDay[hour] || []), event];
    accum.nonFullDay[day] = nextDay;
  }

  if (splitBetweenDays) {
    const endDateStartOfDay = endDate.clone().startOf("days");

    const startOfDayCursor = startDateStartOfDay.clone();
    while (startOfDayCursor.isBefore(endDateStartOfDay)) {
      startOfDayCursor.add(1, "day");

      const day = Object.keys(dates).find((el) =>
        moment.tz(dates[el], timezone).isSame(startOfDayCursor, "days"),
      );

      if (day) {
        const nextDay = accum.nonFullDay[day] || [];
        nextDay[0] = [...(nextDay[0] || []), event] as typeof event[];
        accum.nonFullDay[day] = nextDay;
      }
    }
  }

  return accum;
}
